import { createContext } from "react";
import { ApiService } from "../services";

export const ApiServiceContext = createContext<{ apiService: ApiService }>({
  apiService: new ApiService({}),
});
